import React from 'react';
import { FormSchema } from '../types';
import { SectionSummary, SmallField, inputSmall } from './panelParts';

type ReviewSectionProps = {
  schema: FormSchema;
  setSchema: React.Dispatch<React.SetStateAction<FormSchema>>;
};

export default function ReviewSection({ schema, setSchema }: ReviewSectionProps) {
  return (
          <details data-tour="editor-review" className="group rounded-xl border border-amber-200 border-l-4 border-l-amber-500 bg-amber-50/60 shadow-sm">
            <SectionSummary
              title="Final review step"
              description="Every form ends with a review page"
            />
            <div className="px-3 pb-3">
              <p className="text-[10px] leading-4 text-slate-400">
                Users always review their entries before submitting. Choose which fields appear there with “Show in final review” in each field’s settings.
              </p>
              <div className="mt-3 space-y-2">
                <SmallField label="Review title">
                  <input
                    className={inputSmall()}
                    placeholder="Review & submit"
                    value={schema.review?.title || ''}
                    onChange={(e) => setSchema((current) => ({ ...current, review: { ...current.review, title: e.target.value } }))}
                  />
                </SmallField>
                <SmallField label="Review description">
                  <textarea
                    className={inputSmall()}
                    rows={2}
                    placeholder="Check your information before submitting."
                    value={schema.review?.description || ''}
                    onChange={(e) => setSchema((current) => ({ ...current, review: { ...current.review, description: e.target.value } }))}
                  />
                </SmallField>
              </div>
            </div>
          </details>
  );
}
